import React from "react";
import { Loading } from "./Loading";
import { Auth0Provider } from "@auth0/auth0-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClient = new QueryClient();
const RootLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [origin, setOrigin] = React.useState<string>();

  React.useEffect(() => {
    setOrigin(window.location.origin);
  }, []);

  if (!origin) {
    return <Loading />;
  }
  return (
    <Auth0Provider
      domain={process.env.GATSBY_AUTH0_DOMAIN || ""}
      clientId={process.env.GATSBY_AUTH0_CLIENT_ID || ""}
      authorizationParams={{
        redirect_uri: origin,
        audience: process.env.GATSBY_AUTH0_AUDIENCE,
        scope: "openid profile email",
      }}
    >
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </Auth0Provider>
  );
};

export default RootLayout;
